import Vue from 'vue'
import Router from 'vue-router'

import OutNews from './views/OutNews.vue'
import StockNews from './views/StockNews.vue'
import QhqAnalyst from './views/qhqAnalyst.vue'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [{
            path: '/share/:newsid',
            name: 'share',
            component: OutNews
        },
        {
            path: '/stockshare/:newsid',
            name: 'stockshare',
            component: StockNews
        },
        {
            path: '/qhqAnalyst/:qhqshareid',
            name: 'qhqAnalyst',
            component: QhqAnalyst
        }
    ]
})